const addAudioDescriptive = (video: HTMLVideoElement) => {
  const videoUrl = video.src;
  const [filePart = '', queryParams] = videoUrl.split('?');
  const fileName = filePart
    ?.split('/')
    ?.at(-1)
    ?.replace(/\.(mp3|mp4)$/, '')
    ?.replace(/_(480|720|360|240|1080)$/, '')
    ?.replace(/^(EN|ES)_/, '')
    ?.replace(/_AD/, '') as string;
  const language = filePart?.match(/(EN|ES)_/)?.[0];
  const mainPath = filePart.split('/').slice(0, -1).join('/');

  let lastAttempt = false;

  const checkOnExist = (mp3url: string, mp4url: string) =>
    Promise.all(
      [mp3url, mp4url].map((url) =>
        fetch(url, { method: 'HEAD', credentials: 'include' })
      )
    ).then((responses) => {
      const successfulResponse = responses.find((response) => response.ok);

      if (successfulResponse) {
        video.dataset.originalUrl = video.src;
        video.src = successfulResponse.url;
      } else if (!lastAttempt && !successfulResponse) {
        lastAttempt = true;
        const mp3url = `${mainPath}/${language}${fileName.toLowerCase()}_AD.mp3${
          queryParams ? '?' + queryParams : ''
        }`;
        const mp4url = `${mainPath}/${language}${fileName.toLowerCase()}_AD.mp4${
          queryParams ? '?' + queryParams : ''
        }`;

        checkOnExist(mp3url, mp4url).catch(console.error);
      }
    });

  const mp3url = `${mainPath}/${language}${fileName}_AD.mp3${
    queryParams ? '?' + queryParams : ''
  }`;
  const mp4url = `${mainPath}/${language}${fileName}_AD.mp4${
    queryParams ? '?' + queryParams : ''
  }`;

  checkOnExist(mp3url, mp4url).catch(console.error);
};

export default addAudioDescriptive;
